import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { FaqRequest } from '../api/faq/faqrequest';
import { FaqResponse, FaqResponseDtoImpl } from '../api/faq/faqresponse';
import { FaqBuilder } from '../dto/faq/faqbuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { APIProcessorImpl } from './apiProcessor';
import { Strings } from '../../utils/resources/strings';
import { PropertyReader } from '../../utils/property/propertyreader';
//import { FaqDtoImpl } from '../dto/faq/faqdto';

export class FaqAPIProcessorImpl extends APIProcessorImpl<FaqRequest, FaqResponse>
{

    execute(request: FaqRequest): void {
        new PropertyReader().readProperty("assets/languages/" 
        + this.getContext().getUserContext().getLanguage() +"/FAQ.json", "application/json", 
        {
         onFailure: ()=>{
            this.getAPIFailure(new FaqResponseDtoImpl(APIFeatures.FAQ, this.getContext().getResources().getString(Strings.internal_server_error)));
         }, 
         onSuccess: (propertiesData: any)=> 
         {
            let response = new FaqResponseDtoImpl(APIFeatures.FAQ, "FAQ Success");
            let faqList = new FaqBuilder(propertiesData).buildAll();
                response.setFaqDtos(faqList);

                this.getAPISuccess(response);
         }
     });
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new FaqResponseDtoImpl(APIFeatures.FAQ, "FAQ Success");

                let faqList = new FaqBuilder(responseMapper.getResponseMap()).buildAll();
                response.setFaqDtos(faqList);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new FaqResponseDtoImpl(APIFeatures.FAQ, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new FaqResponseDtoImpl(APIFeatures.FAQ, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new FaqResponseDtoImpl(APIFeatures.FAQ, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
  
            this.getAPIFailure(new FaqResponseDtoImpl(APIFeatures.FAQ, responseMapper.getStatusMsg()));
        
    }

   /*  private faqData()
    {
        let faq1 = new FaqDtoImpl();
        faq1.setFaqQuestion("What is Callertunes Service?");
        faq1.setFaqAnswer("Callertunes service allows you to replace your standard ringing tone to a tone of your choice. Your callers can listen to the tone when they call you.");

        let faq2 = new FaqDtoImpl();
        faq2.setFaqQuestion("How can I Activate Callertune?");
        faq2.setFaqAnswer("You can activate callertune with the options below\n1.\tCall 144 from your Etisalat number and follow the instructions to choose your favorite tone\n2.\tJust send an SMS with the tone id of the song you would like to buy to1100\n3.\tPress * to copy a song that you like, while calling another Etisalat number who has a Tone.\n4.\tVisit https://callertunes.etisalat.ae and purchase the tone from there. After entering your account, you may preview the list, pre-listen, buy or personalize any one of the listed tones available on the web page. To login/register, enter your username and password, where the username is your mobile phone number. You will be asked to enter the OTP for successful registration.\n5.\tDial *444# and select your favourite tune.");

        let faq3 = new FaqDtoImpl();
        faq3.setFaqQuestion("How much does it cost?");
        faq3.setFaqAnswer("Each Tone will cost AED 2 per week. Every second tone purchase will cost only AED 1 per week.");

        let faq4 = new FaqDtoImpl();
        faq4.setFaqQuestion("What will happen if I don't have enough balance on renewal date?");
        faq4.setFaqAnswer("If you have 0.99 AED, you will be successfully subscribed but the tone validity will be only 4 Days.\nIf there is not enough credit, you will be provided a three-day grace period, during which time the system will keep trying to deduct the amount from your account. If the system fails to renew the subscription, the service will be disconnected and you will lose callertune in your album");

        return [faq1, faq2, faq3, faq4];
    } */
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/faqapiprocessor.tsx